import CourseBlockInterface from "../../../Interfaces/CourseBlockInterface";

const CourseHeadBlock = ({
  title,
  duration,
  description,
  hours,
  document_name,
  layout,
  background_color,
}: CourseBlockInterface) => {
  return (
    <div className="headCourseBlock">
      <div className="courseBlockText">
        <h1>{title}</h1>
        <span>{description}</span>
        <div className="courseInfo">
          <div>
            <p>Длительность обучения: </p>
            <p className="courseInfoContent"> {duration}</p>
          </div>
          <div>
            <p>Количество часов:</p>
            <p className="courseInfoContent">{hours}</p>
          </div>

          <div>
            <p>Документы: </p>
            <p className="courseInfoContent">{document_name}</p>
          </div>
        </div>
      </div>
      <div className="moduleImageBlock">
        <img
          alt=""
          src={"https://emir.gtsolifk.ru:4443/assets/" + layout}
          className="headCourseLayout"
        />
        <img
          alt=""
          src={"https://emir.gtsolifk.ru:4443/assets/" + background_color}
          className="headCourseBackground"
        />
      </div>
    </div>
  );
};

export default CourseHeadBlock;
